import { Component } from '@angular/core';
import { TabGroup, Tab, Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-nav-skeleton',
  imports: [TabGroup, Tab, Skeleton],
  templateUrl: './nav-skeleton.html',
})
export class NavSkeleton {}
